import IconComponent from "../IconComponent";

type EditButtonProps = {
  handleOnClick?: () => any;
};

const MobileEditButton = ({ handleOnClick }: EditButtonProps) => {
  return (
    <div
      className="b-r-50 d-flex justify-content-center align-items-center alert-light-info pointer"
      style={{ width: "30px", height: "30px" }}
      onClick={handleOnClick}
    >
      <IconComponent className="icofont icofont-edit-alt f-12 text-dark" />
    </div>
  );
};

export default MobileEditButton;
